<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->
<!-- eslint-disable vue/no-v-html -->

<template>
    <div
        class="sl-order-form__line-column"
        :class="columnClasses"
        @click.stop="$refs.input.focus()"
    >
        <!-- Label -->
        <div class="sl-order-form__label-wrapper">
            <span class="sl-order-form__label">
                {{ parameter.form_label }}
            </span>

            <span v-if="parameter.unit" class="sl-order-form__unit">
                [&nbsp;{{ parameter.unit }}&nbsp;]
            </span>

            <div v-if="helper || note" class="flex-grow"></div>

            <tippy v-if="helper || note">
                <mdi-icon
                    icon="mdiInformationOutline"
                    class="cursor-help inline-block align-middle ml-1 w-4 h-4 text-gray-400"
                />

                <template #content>
                    <div class="text-center text-gray-600">
                        <div class="text-gray-700 font-bold">
                            {{ parameter.form_label }}

                            <span v-if="parameter.unit" class="sl-order-form__unit">
                                [&nbsp;{{ parameter.unit }}&nbsp;]
                            </span>
                        </div>

                        <div
                            v-if="helper"
                            class="sl-order-form__helper"
                            v-html="helper"
                        >
                        </div>

                        <div
                            v-if="note"
                            class="sl-order-form__note"
                            v-html="note"
                        >
                        </div>
                    </div>
                </template>
            </tippy>
        </div>

        <!-- Field -->
        <div class="px-2 py-1">
            <radio-button
                :model-value="modelValue"
                :items="parameter.list_items"
                :nullable="!parameter.is_required"
                :tabindex="tabIndex"
                class="sl-order-form__field-wrapper lsn-form__radio-item-wrapper"
                @update:model-value="$emit('update:modelValue', $event)"
            />
        </div>

        <!-- Error -->
        <div v-if="error" class="mb-1 px-2 text-red-600 text-xs text-center">
            {{ error }}
        </div>
    </div>
</template>

<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>
import AbstractField from './AbstractField.vue';
import RadioButton from '@/components/RadioButton.vue';

export default
{
    name: 'InlineRadioButtonField',

    components:
    {
        RadioButton,
    },

    extends: AbstractField,

    emits: ['update:modelValue'],

    data()
    {
        return {
            isTouched: false,
        };
    },

    computed:
    {
        helper()
        {
            return null;
        },

        note()
        {
            return this.parameter.note;
        },
    },
};
</script>

<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style scoped>
@reference "#main.css";

.sl-order-form__line-column,
.sl-order-form__unit
{
    @apply cursor-text;
}

.sl-order-form__line-column .sl-order-form__field-wrapper.lsn-form__radio-item-wrapper
{
    @apply mx-0 w-full;
}
</style>
